import { createContext, useContext } from 'react';

import { PartialVendorSearch } from '../types/types';

export type NavigateToSrpFunction = (change: PartialVendorSearch) => void;

export type VendorSearchNavigationValues = {
  /**
   * Performs a new search on the SRP
   * - If the location or category has changed, it reloads the page
   * - If the filters have changed, it updates the results without reloading the page
   */
  navigateToSrp: NavigateToSrpFunction;
};

export const DEFAULT_VENDOR_SEARCH_NAVIGATION_CONTEXT_VALUES: VendorSearchNavigationValues = {
  navigateToSrp: () => undefined,
};

export const VendorSearchNavigationContext = createContext<
  VendorSearchNavigationValues | undefined
>(undefined);

/**
 * Encapsulates the logic for navigating on the SRP
 *
 * @example
 * const { navigateToSrp } = useVendorSearchNavigation();
 * navigateToSrp({ page: 2 });
 *
 */
export const useVendorSearchNavigation = () => {
  const context = useContext(VendorSearchNavigationContext);
  if (context === undefined) {
    throw new Error(
      'useVendorSearchNavigation must be used within a VendorSearchNavigationContext'
    );
  }
  return context;
};
